import React from 'react';
import { motion } from 'framer-motion';

const CanetaPersonagem = ({ 
  estado = 'normal', // normal, feliz, triste, pensando, celebrando
  tamanho = 'md', // sm, md, lg
  className = '' 
}) => {
  const tamanhos = {
    sm: 'w-16 h-16',
    md: 'w-24 h-24',
    lg: 'w-32 h-32'
  };

  const animacoes = {
    normal: {
      rotate: [0, -5, 5, 0],
      transition: {
        duration: 2,
        repeat: Infinity,
        ease: "easeInOut"
      }
    },
    feliz: {
      rotate: [0, -10, 10, -5, 5, 0],
      y: [0, -5, 0],
      transition: {
        duration: 1,
        repeat: Infinity,
        ease: "easeInOut"
      }
    },
    triste: {
      rotate: [0, -2, 2, 0],
      y: [0, 2, 0],
      transition: {
        duration: 3,
        repeat: Infinity,
        ease: "easeInOut"
      }
    },
    pensando: {
      rotate: [0, -15, 0, 15, 0],
      transition: {
        duration: 2,
        repeat: Infinity,
        ease: "easeInOut"
      }
    },
    celebrando: {
      rotate: [0, -20, 20, -15, 15, -10, 10, 0],
      y: [0, -10, 0, -8, 0, -5, 0],
      scale: [1, 1.1, 1, 1.05, 1],
      transition: {
        duration: 1.5,
        repeat: Infinity,
        ease: "easeInOut"
      }
    }
  };

  const cores = {
    normal: '#f59e0b', // golden-500
    feliz: '#10b981', // emerald-500
    triste: '#6b7280', // gray-500
    pensando: '#8b5cf6', // violet-500
    celebrando: '#f59e0b' // golden-500
  };

  const expressoes = {
    normal: '😊',
    feliz: '😄',
    triste: '😔',
    pensando: '🤔',
    celebrando: '🎉'
  };

  return (
    <div className={`relative flex items-center justify-center ${className}`}>
      {/* Caneta animada */}
      <motion.div
        className={`relative ${tamanhos[tamanho]} flex items-center justify-center`}
        animate={animacoes[estado]}
      >
        {/* Corpo da caneta */}
        <svg
          viewBox="0 0 100 100"
          className="w-full h-full drop-shadow-lg"
          style={{ filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.2))' }}
        >
          {/* Corpo principal */}
          <rect
            x="35"
            y="20"
            width="30"
            height="60"
            rx="15"
            fill={cores[estado]}
            stroke="#d97706"
            strokeWidth="2"
          />
          
          {/* Ponta da caneta */}
          <polygon
            points="45,80 55,80 50,95"
            fill="#374151"
            stroke="#1f2937"
            strokeWidth="1"
          />
          
          {/* Tampa/clip */}
          <rect
            x="45"
            y="15"
            width="10"
            height="10"
            rx="2"
            fill="#6b7280"
          />
          
          {/* Clip da caneta */}
          <rect
            x="48"
            y="10"
            width="4"
            height="15"
            rx="2"
            fill="#9ca3af"
          />
          
          {/* Detalhes decorativos */}
          <circle cx="50" cy="35" r="3" fill="#fbbf24" opacity="0.7" />
          <circle cx="50" cy="45" r="2" fill="#fbbf24" opacity="0.5" />
          <circle cx="50" cy="55" r="2" fill="#fbbf24" opacity="0.5" />
          
          {/* Brilho */}
          <ellipse
            cx="42"
            cy="30"
            rx="3"
            ry="8"
            fill="white"
            opacity="0.3"
          />
        </svg>
        
        {/* Expressão facial */}
        <motion.div
          className="absolute text-lg"
          style={{ top: '25%', left: '50%', transform: 'translateX(-50%)' }}
          animate={{
            scale: estado === 'celebrando' ? [1, 1.2, 1] : 1,
          }}
          transition={{
            duration: 0.5,
            repeat: estado === 'celebrando' ? Infinity : 0,
          }}
        >
          {expressoes[estado]}
        </motion.div>
      </motion.div>
      
      {/* Efeitos especiais */}
      {estado === 'celebrando' && (
        <div className="absolute inset-0 pointer-events-none">
          {[...Array(6)].map((_, i) => (
            <motion.div
              key={i}
              className="absolute w-2 h-2 bg-golden-400 rounded-full"
              style={{
                left: `${20 + i * 10}%`,
                top: `${30 + (i % 2) * 20}%`,
              }}
              animate={{
                y: [-10, -20, -10],
                opacity: [0, 1, 0],
                scale: [0, 1, 0],
              }}
              transition={{
                duration: 1,
                repeat: Infinity,
                delay: i * 0.1,
              }}
            />
          ))}
        </div>
      )}
      
      {estado === 'pensando' && (
        <motion.div
          className="absolute -top-2 -right-2 text-xs"
          animate={{
            opacity: [0, 1, 0],
            scale: [0.8, 1, 0.8],
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
          }}
        >
          💭
        </motion.div>
      )}
      
      {estado === 'feliz' && (
        <div className="absolute inset-0 pointer-events-none">
          {[...Array(3)].map((_, i) => (
            <motion.div
              key={i}
              className="absolute text-yellow-400"
              style={{
                left: `${30 + i * 20}%`,
                top: `${20 + i * 10}%`,
              }}
              animate={{
                y: [0, -15, 0],
                opacity: [0, 1, 0],
                rotate: [0, 180, 360],
              }}
              transition={{
                duration: 1.5,
                repeat: Infinity,
                delay: i * 0.3,
              }}
            >
              ⭐
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CanetaPersonagem;
